import { render, staticRenderFns } from "./CNCDashboardPanel.vue?vue&type=template&id=25a34bf0&scoped=true"
import script from "./CNCDashboardPanel.vue?vue&type=script&lang=ts"
export * from "./CNCDashboardPanel.vue?vue&type=script&lang=ts"
import style0 from "./CNCDashboardPanel.vue?vue&type=style&index=0&id=25a34bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a34bf0",
  null
  
)

export default component.exports